<!-- 球队管理 -->
<template>
    <div>
        <event-head></event-head>
        <div class="mt-3">
            <el-table :data="personinfo" style="width: 100%" :header-cell-style="{
                color: '#fff',
                fontSize: '14px',
                height: '40px',
                width: '100%',
            }">
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="date" label="日期" align="center"></el-table-column>
                <el-table-column prop="saas" label="SaaS订阅收入" align="center"></el-table-column>
                <el-table-column prop="Share" label="合伙人分成收入" align="center"></el-table-column>
                <!-- <el-table-column prop="bankcard" label="银行卡号" align="center"></el-table-column> -->
            </el-table>
            <!-- <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
            :page-size="pageInfo.pageSize" :total="pageInfo.count"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination> -->
        </div>
    </div>
</template>

<script>
import EventHead from '@/common/components/eventHead/EventHead';
export default {
    components: {
        EventHead
    },
    data() {
        return {
            pageInfo: {
                page: 1,
                pageSize: 10,
                count: 0,
            },
            personinfo:[{
                index:'1',
                Share:'¥ 1,900.00',
                saas:'¥ 3,800.00',
                date:'2025/07/01',
                personId:'1123xxxxxx2252',
                bank:'中国工商银行',
                bankcard:'2255xxxxx111'
            }]

        };
    },
    mounted() {

    },
    methods: {


        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
        },
        handleCurrentChange(val) {
            this.pageInfo.page = val;
        },

    },
};
</script>

<style lang="scss" scoped>
.cardinal {
    margin-top: 30px;
}

.addMatch {
    margin-left: 30px;
    font-size: 16px;
    color: #000;

}

/deep/.el-input--small .el-input__inner {
    height: 32px;
    line-height: 32px;
    background-color: transparent;
    opacity: 1;
    border: none;
    border-bottom: 1px solid #9b9b9b;
    color: #fff;
    border-radius: 0;
}

.bottom_btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;

    .addVenue {
        color: #fff;
    }
}
</style>